import dayjs from "dayjs";

export const NAVY = "#0E2240";
export const GOLD = "#BF9B30";
export const CRIMSON = "#BB162B";
export const GREEN = "#2F6B4F";
export const DARKRED = "#7A0E1C";
export const AMBER = "#C97F10";

export const BUCKET_COLORS = { green: GREEN, amber: AMBER, red: CRIMSON, darkred: DARKRED };

/* Stable recharts prop objects — recreating them inline forces chart re-renders. */
export const SPARK_MARGIN = { top: 2, right: 0, left: 0, bottom: 0 };
export const TREND_MARGIN = { top: 8, right: 12, left: -14, bottom: 0 };
export const AXIS_TICK = { fontSize: 11 };
export const TOOLTIP_STYLE = { fontSize: 12, borderRadius: 8 };
export const LEGEND_STYLE = { fontSize: 12 };

export const periodStartISO = (period) => {
  if (period === "today") return dayjs().format("YYYY-MM-DD");
  if (period === "week") {
    const d = new Date();
    const monday = new Date(d);
    monday.setDate(d.getDate() - ((d.getDay() + 6) % 7));
    return dayjs(monday).format("YYYY-MM-DD");
  }
  return dayjs().startOf("month").format("YYYY-MM-DD");
};

export const monthStartISO = () => dayjs().startOf("month").format("YYYY-MM-DD");

/* Shaded month runs where opened > closed (inflow exceeded outflow). */
export const computeShadeRuns = (trend) => {
  const runs = [];
  let start = null;
  trend.forEach((m, i) => {
    if (m.opened > m.closed) {
      if (start === null) start = m.month;
      if (i === trend.length - 1) runs.push([start, m.month]);
    } else if (start !== null) {
      runs.push([start, trend[Math.max(0, i - 1)].month]);
      start = null;
    }
  });
  return runs;
};

export const teamLabel = (fn) => {
  if (fn === "Sales") return "Consultants";
  if (fn === "Service") return "Service advisors";
  return "Team members";
};
